<template>
  <div class="form-group" :class="{ 'has-error': hasError }">
    <label class="control-label" v-if="label">{{ label }}</label>
    <textarea
      class="form-control"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)"
      v-on="listeners"
      v-bind="$attrs"
      :rows="rows"
    ></textarea>
    <span class="help-block" v-if="hasError">{{ errors[0] }}</span>
    <span class="text-warning" v-if="hasWarnings">{{ warnings[0] }}</span>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, String],
      default: '',
    },
    rows: {
      type: Number,
      default: 5,
    },
    type: {
      type: String,
      default: 'text',
    },
    errors: {
      type: Array,
      default: () => [],
    },
    warnings: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    listeners() {
      const listeners = { ...this.$listeners };

      delete listeners.input;

      return listeners;
    },
    hasError() {
      return this.errors && this.errors.length;
    },
    hasWarnings() {
      return this.warnings && this.warnings.length;
    },
  },
};
</script>
